import React, { PureComponent } from 'react';
import { Link } from 'react-router';

import getUrl from '@/routes/routes/helpers/getUrl';

import {
  acceptanceButton,
  acceptanceButtonWrapper,
  acceptanceRow,
  acceptanceText,
  banner,
  cookiePolicyLink,
} from './styles.module.css';

class CookiePolicyBanner extends PureComponent {
  render() {
    const { onAccept } = this.props;

    return (
      <div id="cookieAcceptanceModal" className={banner}>
        <div className={acceptanceRow}>
          <div className={acceptanceText}>
            <span>
              By using this website you agree to our{' '}
              <Link
                className={cookiePolicyLink}
                to={`${WEB_ROOT}${getUrl.cookiePolicy()}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                cookie policy
              </Link>
            </span>
          </div>
          <div className={acceptanceButtonWrapper}>
            <Link onClick={onAccept} rel="noreferrer noopener">
              <div className={acceptanceButton}>Dismiss</div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default CookiePolicyBanner;
